import { Logger } from '@halo/utils';

export const storeLogger = new Logger('store');
